import { useSyncExternalStore } from 'react';

import { analyticsAvailable, loadAnalytics } from '../../analytics';

/**
 * Consentimiento de cookies de analítica (Google Analytics). Es del dispositivo: queda en
 * localStorage y, mientras no haya respuesta, Analytics no carga y se muestra el aviso.
 */
export const COOKIE_CONSENT_KEY = 'parche-cafetero:cookies';

export type CookieConsent = 'granted' | 'denied';

const listeners = new Set<() => void>();
let memory: CookieConsent | null = null;

export function readConsent(): CookieConsent | null {
  try {
    const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    return value === 'granted' || value === 'denied' ? value : memory;
  } catch {
    return memory;
  }
}

export function setConsent(value: CookieConsent): void {
  memory = value;
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch {
    // Sin almacenamiento (modo privado): la respuesta vale solo mientras la página esté abierta.
  }
  if (value === 'granted') loadAnalytics();
  for (const listener of [...listeners]) listener();
}

/** Carga Analytics al abrir la app si ya lo había aceptado. */
export function applyStoredConsent(): void {
  if (readConsent() === 'granted') loadAnalytics();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** `true` mientras falte preguntar (y solo donde Analytics puede cargar). */
export function useConsentPending(): boolean {
  return useSyncExternalStore(subscribe, () => analyticsAvailable() && readConsent() === null);
}

/** Solo para pruebas. */
export function resetConsent(): void {
  memory = null;
}
